import { defineComponent, reactive, ref, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { SMI2_URL } from '~/components/Smi2';
import { ADFOX_FETCH_STATES } from '~/components/Adfox';
import Smi2Logo from '~/assets/images/smi2.svg?inline';
export default defineComponent({
    name: 'Smi2Mobile',
    components: {
        Smi2Logo,
    },
    emits: ['complete'],
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const news = ref();
        const error = reactive({});
        const state = reactive({ ...ADFOX_FETCH_STATES });
        const fetchNewsTask = useTask(function* (_, observer) {
            state.isRendered = false;
            try {
                const response = yield fetch(SMI2_URL);
                state.isLoaded = true;
                const contentType = response?.headers.get('Content-Type');
                if (!contentType || !contentType.includes('application/json')) {
                    return throwError('Response is not JSON', response);
                }
                if (!response.ok) {
                    return throwError(`Request is complete with status ${response.status}`, response);
                }
                const data = yield response.json();
                news.value = data.news.slice(0, 3);
                state.isRendered = true;
            }
            catch (e) {
                throwError('', e);
            }
            finally {
                state.isCompleted = true;
                emit('complete', { error, state });
                observer.disconnect();
            }
        });
        function handleIntersect({ observer }) {
            fetchNewsTask.perform(observer);
        }
        function throwError(message = '', payload = '') {
            state.withError = true;
            error.message = message;
            console.error('[Smi2Mobile]', message, payload);
        }
        return {
            css,
            error,
            fetchNewsTask,
            handleIntersect,
            news,
            state,
        };
    },
});
